(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setAnnouncementHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setAnnouncementHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementHeight() {
      const announcementSection = document.querySelector('.announcement-bar-section');
      const height = announcementSection ? announcementSection.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class MenuHeaderScroll extends HTMLElement {
    constructor() {
      super();
      this.scrollOffset = '61px';
      this.handleScroll = this.handleScroll.bind(this);
      this.checkScreenSize = this.checkScreenSize.bind(this);
    }

    connectedCallback() {
      this.announcement = document.querySelector(".announcement-bar");
      this.headerMenu = document.querySelector('.header__inline-menu');
      this.headerIcons = document.querySelector('.header__icons');

      this.setAnnouncementHeight();

      if (!this.headerMenu || !this.headerIcons) {
        console.warn('MobileHeaderScroll: Missing required elements');
        return;
      }

      this.checkScreenSize();
      window.addEventListener('resize', this.checkScreenSize);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.checkScreenSize);
    }

    setAnnouncementHeight() {
      if(this.announcement) {
        document.documentElement.style.setProperty('--announcement-height', `${this.announcement.offsetHeight}px`);
      }
    }

    handleScroll() {
      const currentScrollY = window.scrollY;

      if (currentScrollY < 50) {
        this.headerMenu.style.top = this.scrollOffset;
        this.headerIcons.style.top = this.scrollOffset;
      } else {
        this.headerMenu.style.top = '0';
        this.headerIcons.style.top = '3px';
      }
    }

    checkScreenSize() {
      if (!this.headerMenu || !this.headerIcons) return;

      if (window.innerWidth <= 849) {
        window.addEventListener('scroll', this.handleScroll);
        this.headerMenu.style.top = this.scrollOffset;
        this.headerIcons.style.top = this.scrollOffset;
      } else {
        window.removeEventListener('scroll', this.handleScroll);
        if(this.announcement) {
          this.headerMenu.style.top = `${this.announcement?.offsetHeight + 10}px`;
        } else {
          this.headerMenu.style.top = `10px`;
        }
       
        this.headerIcons.style.top = 'unset';
      }
    }
  }

  customElements.define('menu-header-scroll', MenuHeaderScroll);

  
  

  } catch(e) { console.error(e); }
})();
})();
